const INSTALL_FLOW_KEYS = {
  // sessionStorage
  SENSOR_KIT_SERIAL:     'installFlowSensorKitSerialNumber',
  LOCATION_ID:           'installFlowLocationId',
  LOCATION_NAME:         'installFlowLocationName',
  SUBLOCATION_ID:        'installFlowSublocationId',
  SUBLOCATION_NAME:      'installFlowSublocationName',
  INSTALLATION_ID:       'installFlowInstallationId',
  ASSET_NAME:            'installFlowAssetName',
  ASSET_TYPE:            'installFlowAssetType',
  SCAN_ID:               'installFlowScanId',
  SERIAL_NUMBER:         'installFlowSerialNumber',
  MANUFACTURER:          'installFlowManufacturer',
  MANUFACTURER_ID:       'installFlowManufacturerId',
  MODEL_NUMBER:          'installFlowModelNumber',
  MODEL_ID:              'installFlowModelId',
  ADDRESS:               'installFlowAddress',
  EMAIL:                 'installFlowEmail',
  TECHNIQUE_PHOTO:       'installFlowTechniquePhoto',
  // localStorage
  ORGANIZATION_ID:       'installFlowOrganizationId',
  ORGANIZATION_NAME:     'installFlowOrganizationName',
  IDENTIFICATION_RESULT: 'installFlowIdentificationResult',
} as const

function makeInstallFlowAccessor(key: keyof typeof INSTALL_FLOW_KEYS, storage: Storage = sessionStorage) {
  const storageKey = INSTALL_FLOW_KEYS[key]
  return {
    get: (): string | null => storage.getItem(storageKey),
    set: (value: string): void => { storage.setItem(storageKey, value) },
    remove: (): void => { storage.removeItem(storageKey) },
  }
}

// sessionStorage accessors (cleared when the tab closes)
export const installFlowSensorKitSerial = makeInstallFlowAccessor('SENSOR_KIT_SERIAL')
export const installFlowLocationId      = makeInstallFlowAccessor('LOCATION_ID')
export const installFlowLocationName    = makeInstallFlowAccessor('LOCATION_NAME')
export const installFlowSublocationId   = makeInstallFlowAccessor('SUBLOCATION_ID')
export const installFlowSublocationName = makeInstallFlowAccessor('SUBLOCATION_NAME')
export const installFlowInstallationId  = makeInstallFlowAccessor('INSTALLATION_ID')
export const installFlowAssetName       = makeInstallFlowAccessor('ASSET_NAME')
export const installFlowAssetType       = makeInstallFlowAccessor('ASSET_TYPE')
export const installFlowScanId          = makeInstallFlowAccessor('SCAN_ID')
export const installFlowSerialNumber    = makeInstallFlowAccessor('SERIAL_NUMBER')
export const installFlowManufacturer    = makeInstallFlowAccessor('MANUFACTURER')
export const installFlowManufacturerId  = makeInstallFlowAccessor('MANUFACTURER_ID')
export const installFlowModelNumber     = makeInstallFlowAccessor('MODEL_NUMBER')
export const installFlowModelId         = makeInstallFlowAccessor('MODEL_ID')
export const installFlowAddress         = makeInstallFlowAccessor('ADDRESS')
export const installFlowEmail           = makeInstallFlowAccessor('EMAIL')
export const installFlowTechniquePhoto  = makeInstallFlowAccessor('TECHNIQUE_PHOTO')

// localStorage accessors (persisted across sessions)
export const installFlowOrganizationId       = makeInstallFlowAccessor('ORGANIZATION_ID', localStorage)
export const installFlowOrganizationName     = makeInstallFlowAccessor('ORGANIZATION_NAME', localStorage)
export const installFlowIdentificationResult = makeInstallFlowAccessor('IDENTIFICATION_RESULT', localStorage)